import React, { useEffect, useRef, useState, useMemo } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import ReactSlider from "react-slider";
import { Button } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import PropertyList from "./PropertyList";
import PropertyList from "./PropertyListCaroline";
import ButtonFilter from "./ButtonFilter"; // Import the child component
import Header from "./Header";
import { ToastContainer } from "react-toastify";
import Modal from "react-modal";
import * as turf from "@turf/turf";

mapboxgl.accessToken =
  "pk.eyJ1IjoiYWJoaWppdGgxMjc5IiwiYSI6ImNtNGNqdzE4NDA2MGoyaXFwdXh6cjVqMWQifQ.OpRKi-Zt3NIOjXFz-hd-DA";

const CarolinaComponent= () => {
  const mapContainer = useRef(null);
  const mapViewControlRef = useRef(null);
  const mapRef = useRef(null);

  const [parcelData, setParcelData] = useState([]);
  const [filteredParcels, setFilteredParcels] = useState([]);

  // Filter states
  const [showPriceFilter, setShowPriceFilter] = useState(false);
  const [showAreaFilter, setShowAreaFilter] = useState(false);
  const [showAppreciationFilter, setShowAppreciationFilter] = useState(false);
  const [appreciationFilter, setAppreciationFilter] = useState("All"); // State for Appreciation filter
  const [showZoneFilter, setShowZoneFilter] = useState(false);
  const [priceRange, setPriceRange] = useState([0, 1000000]);
  const [areaRange, setAreaRange] = useState([0, 5000]);
  const [appreciationValue, setAppreciationValue] = useState("All");
  const [zoneCodeFilter, setZoneCodeFilter] = useState("All");

  const [sliderMinPrice, setSliderMinPrice] = useState(0);
  const [sliderMaxPrice, setSliderMaxPrice] = useState(1000000);
  const [sliderMinArea, setSliderMinArea] = useState(0);
  const [sliderMaxArea, setSliderMaxArea] = useState(5000);

  const [showFloodFilter, setShowFloodFilter] = useState(false);
  const [floodRiskFilter, setFloodRiskFilter] = useState("All");
  const [showPoints, setShowPoints] = useState(false);

  // new filters
  const [showZestimateFilter, setShowZestimateFilter] = useState(false);
  const [zestimateRange, setZestimateRange] = useState([50000, 2000000]); // replace with dynamic min/max
  const [listedSaleFilter, setListedSaleFilter] = useState("All");
  const [listedSaleOptions, setListedSaleOptions] = useState([]);
  const [showSpreadFilter, setShowSpreadFilter] = useState(false);
  const [spreadRange, setSpreadRange] = useState([0, 100]);
  const [floodOptions, setFloodOptions] = useState(["All"]);
  const [showListedSaleFilter, setShowListedSaleFilter] = useState(false);
  const [showOnlyListed, setShowOnlyListed] = useState(false);
  // define slider limits
  const [showCountyFilter, setShowCountyFilter] = useState(false);
  const [countyFilter, setCountyFilter] = useState("All");
  const [countyOptions, setCountyOptions] = useState(["All"]);



  const [sliderMinZestimate, setSliderMinZestimate] = useState(0);
  const [sliderMaxZestimate, setSliderMaxZestimate] = useState(1000000);


  // Spread %
  const [sliderMinSpread, setSliderMinSpread] = useState(-100);
  const [sliderMaxSpread, setSliderMaxSpread] = useState(100);
  // const parcelFile = "matched_fema_intersect.geojson";
  //   const parcelFile = "northcarolina_custom_parcels_floodhazard.geojson";
  const parcelFile = "northcarolina_parcels_flood_spread.geojson";

  // local UI states to match main page layout
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(
    localStorage.getItem("isSubscribed") === "true"
  );
  const geocoderContainerRef = useRef(null);

  const toggleMenu = () => setIsMenuOpen((s) => !s);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    window.location.href = "/";
  };

  const handleTabChange = () => { };

  const FLOOD_ZONE_LEGEND = [

    { zone: "X", color: "#4CAF50", label: "X - Minimal Risk" },
    { zone: "AE", color: "#FF9800", label: "AE - High Risk + BFE" },
    { zone: "VE", color: "#E91E63", label: "VE - Coastal + BFE" },
    { zone: "A", color: "#2196F3", label: "A - High Risk (No BFE)" },

    // { zone: "X", color: "#4CAF50", label: "X - Minimal Risk" },
    // { zone: "AE", color: "#FF9800", label: "AE - Base Floodplain" },
    // { zone: "VE", color: "#E91E63", label: "VE - Coastal + Waves" },
    // { zone: "A", color: "#2196F3", label: "A - No Elevation Data" },

  ];

  //  FLOOD ZONE LEGEND CONTROL CLASS
  class FloodZoneLegendControl {
    constructor(legendData) {
      this.legendData = legendData;
    }

    onAdd(map) {
      this._map = map;
      this._container = document.createElement("div");
      this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group";

      // Container styles
      Object.assign(this._container.style, {
        background: "rgba(255, 255, 255, 0.95)",
        padding: "10px 12px",
        borderRadius: "4px",
        boxShadow: "0 0 0 2px rgba(0,0,0,.1)",
        fontFamily: "Inter, sans-serif",
        fontSize: "12px",
        minWidth: "200px",
        maxWidth: "250px",
        marginBottom: "10px", // Space from bottom edge
      });

      // Title
      const title = document.createElement("div");
      title.textContent = "FEMA Flood Zones";
      Object.assign(title.style, {
        fontWeight: "600",
        color: "#333",
        fontSize: "13px",
        marginBottom: "8px",
        borderBottom: "1px solid #ddd",
        paddingBottom: "6px",
      });
      this._container.appendChild(title);

      // Legend items container
      const itemsContainer = document.createElement("div");
      Object.assign(itemsContainer.style, {
        display: "flex",
        flexDirection: "column",
        gap: "6px",
      });

      // Add each legend item
      this.legendData.forEach((item) => {
        const row = document.createElement("div");
        Object.assign(row.style, {
          display: "flex",
          alignItems: "center",
          gap: "8px",
        });

        // Color box
        const colorBox = document.createElement("div");
        Object.assign(colorBox.style, {
          width: "20px",
          height: "20px",
          backgroundColor: item.color,
          opacity: "0.7",
          borderRadius: "3px",
          border: "1px solid rgba(0,0,0,0.2)",
          flexShrink: "0",
        });

        // Label text
        const label = document.createElement("span");
        label.textContent = item.label;
        Object.assign(label.style, {
          color: "#555",
          fontSize: "11px",
          lineHeight: "1.4",
        });

        row.appendChild(colorBox);
        row.appendChild(label);
        itemsContainer.appendChild(row);
      });

      this._container.appendChild(itemsContainer);

      return this._container;
    }

    onRemove() {
      if (this._container && this._container.parentNode) {
        this._container.parentNode.removeChild(this._container);
      }
      this._map = undefined;
    }
  }


  //  Center map on county with smooth animation
useEffect(() => {
  if (!mapRef.current || !countyFilter || countyFilter === "All") {
    // Reset to default view when "All" is selected
    if (countyFilter === "All" && mapRef.current) {
      mapRef.current.flyTo({
        center: [-78.6443, 35.7877], // North Carolina center
        zoom: 12,
        duration: 2000,
        essential: true,
      });
    }
    return;
  }
  
  // Filter parcels by selected county
  const countyParcels = parcelData.filter((f) => {
    const p = f.properties || {};
    const county = p.county || p.County || p.COUNTY || "Unknown";
    return String(county).toLowerCase() === String(countyFilter).toLowerCase();
  });

  if (countyParcels.length === 0) {
    console.warn(`No parcels found for county: ${countyFilter}`);
    return;
  }

  try {
    // Extract valid coordinates
    const coords = countyParcels
      .map(f => {
        const p = f.properties || {};
        const lon = parseFloat(p.longitude);
        const lat = parseFloat(p.latitude);
        if (isNaN(lon) || isNaN(lat)) return null;
        return [lon, lat];
      })
      .filter(Boolean);

    if (coords.length === 0) return;

    // Calculate center using Turf
    const points = coords.map(c => turf.point(c));
    const collection = turf.featureCollection(points);
    const center = turf.center(collection);
    const bbox = turf.bbox(collection);

    // Calculate appropriate zoom level based on bbox size
    const lngDiff = bbox[2] - bbox[0];
    const latDiff = bbox[3] - bbox[1];
    const maxDiff = Math.max(lngDiff, latDiff);
    
    let zoomLevel = 13;
    if (maxDiff > 0.5) zoomLevel = 10;
    else if (maxDiff > 0.2) zoomLevel = 11;
    else if (maxDiff > 0.1) zoomLevel = 12;

    // Animate to county center
    mapRef.current.flyTo({
      center: center.geometry.coordinates,
      zoom: zoomLevel,
      duration: 2000,
      essential: true,
      pitch: 0,
    });

    console.log(`✅ Map centered on ${countyFilter} County at zoom ${zoomLevel}`);
  } catch (err) {
    console.error("Error centering map on county:", err);
  }
}, [countyFilter, parcelData]);

  // --- compute zone codes from data ---
  const zoneCodes = useMemo(() => {
    const codes = new Set();

    // Filter parcels by county first
    const parcelsToUse = countyFilter === "All"
      ? parcelData
      : parcelData.filter((f) => {
        const p = f.properties || {};
        const county = p.county || p.County || p.COUNTY || "Unknown";
        return String(county).toLowerCase() === String(countyFilter).toLowerCase();
      });


    // parcelData.forEach((f) => {
    parcelsToUse.forEach((f) => {
      const p = f.properties || {};
      const z =
        p.zonedcodelocal ??

        p.ZonedCodeLocal ??
        p.ZonedCode ??
        p.ZoneCode ??
        p.zoning ??
        p.zoning_code ??
        "Unknown";
      if (z) codes.add(String(z));
    });
    return ["All", ...Array.from(codes).sort()];
  }, [parcelData, countyFilter]);

  // helper: build color match expression for mapbox layers by zone code
  const buildZoneColorExpression = (features) => {
    const palette = [
      "#4CAF50",
      "#16DBCC",
      "#D009D0",
      "#16A9F2",
      "#FFB300",
      "#8E24AA",
      "#FB8C00",
      "#F06292",
      "#90A4AE",
      "#42A5F5",
    ];
    const codes = Array.from(
      new Set(
        (features || []).map((f) => f.properties?.ZonedCodeLocal || f.properties?.ZonedCode || "Unknown")
      )
    ).slice(0, 50);
    const expr = ["match", ["get", "ZonedCodeLocal"]];
    codes.forEach((c, idx) => {
      expr.push(c, palette[idx % palette.length]);
    });
    expr.push("#cccccc"); // default
    return expr;
  };

  class MapViewToggleControl {
    constructor(onPolygonClick, onPointClick, showPoints = false) {
      this.onPolygonClick = onPolygonClick;
      this.onPointClick = onPointClick;
      this.showPoints = !!showPoints;
    }

    _createButton(label, handler) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.textContent = label;
      Object.assign(btn.style, {
        padding: "6px 14px",
        //   border: "1px solid #fff",
        borderRadius: "20px",
        cursor: "pointer",
        fontWeight: "600",
        fontSize: "12px",
        color: "#fff",
        backgroundColor: "transparent",
        transition: "background 0.18s, color 0.18s",
        borderColor: 'transparent'
      });
      // store active flag
      btn._isActive = false;

      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        handler && handler();
      });

      btn.addEventListener("mouseenter", () => {
        btn.style.filter = "brightness(0.95)";
      });
      btn.addEventListener("mouseleave", () => {
        btn.style.filter = "none";
      });

      return btn;
    }

    _applyActiveStyle(btn, active) {
      btn._isActive = !!active;
      if (btn._isActive) {
        //   btn.style.backgroundColor= "rgb(255, 255, 255);";

        //   btn.style.color = "#000";
        //   btn.style.borderRadius = "20px";

        btn.style.backgroundColor = "#ffffff";
        btn.style.color = "#000000";
        btn.style.borderRadius = "20px";

      } else {



        btn.style.backgroundColor = "transparent";
        btn.style.color = "#ffffff";
        btn.style.borderRadius = "20px";
        btn.style.boxShadow = "none";

      }
    }

    onAdd(map) {
      this.map = map;
      this.container = document.createElement("div");

      Object.assign(this.container.style, {
        position: "absolute",
        top: "10px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: "10",
        backgroundColor: "rgba(0,0,0,0.38)",
        padding: "5px 10px",
        borderRadius: "30px",
        display: "flex",
        gap: "10px",
        //   boxShadow: "0 2px 5px rgba(0,0,0,0.3)",
        fontSize: "12px",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "auto",

      });

      this.polygonBtn = this._createButton("Polygons", () => {
        this.update(false);
        if (typeof this.onPolygonClick === "function") this.onPolygonClick();
      });

      this.pointsBtn = this._createButton("Points", () => {
        this.update(true);
        if (typeof this.onPointClick === "function") this.onPointClick();
      });

      this.container.appendChild(this.polygonBtn);
      this.container.appendChild(this.pointsBtn);

      // initial active state
      this.update(this.showPoints);

      return this.container;
    }

    // update which button is visually active (true -> points active)
    update(isPoints) {
      this.showPoints = !!isPoints;
      if (this.polygonBtn && this.pointsBtn) {
        this._applyActiveStyle(this.polygonBtn, !this.showPoints);
        this._applyActiveStyle(this.pointsBtn, this.showPoints);
      }
    }

    onRemove() {
      if (this.container && this.container.parentNode) {
        this.container.parentNode.removeChild(this.container);
      }
      this.map = undefined;
    }
  }

  const handleRowClick1 = (property) => {
    console.log("handleRowClick called with:", property); //  ADD: Debug log

    if (!property) {
      console.warn("Property is null or undefined");
      return;
    }

    if (!mapRef.current) {
      console.warn("ParcelMap ref not available");
      return;
    }

    //  Try multiple property name variations
    const lat = parseFloat(
      property.latitude ||
      property.lat ||
      property.Latitude ||
      property.intptlat ||
      property.properties?.latitude ||
      property.properties?.lat
    );

    const lng = parseFloat(
      property.longitude ||
      property.lon ||
      property.lng ||
      property.Longitude ||
      property.intptlon ||
      property.properties?.longitude ||
      property.properties?.lon
    );

    console.log("Extracted coordinates:", { lat, lng }); //  ADD: Debug log

    if (isNaN(lat) || isNaN(lng)) {
      console.warn("Invalid coordinates for property:", property);
      console.warn("Available property keys:", Object.keys(property));
      return;
    }

    // Call the ParcelMap's flyToLocation method via ref
    if (typeof mapRef.current.flyToLocation === 'function') {
      console.log("Calling flyToLocation:", lng, lat); //  ADD: Debug log
      mapRef.current.flyToLocation(lng, lat, property);
    } else {
      console.warn("flyToLocation method not available on parcelMapRef.current");
    }
  };
  const handleRowClick = (property) => {
    console.log("handleRowClick called with:", property);
    if (!mapRef.current) return;

    //  Extract coordinates from FEMA GeoJSON properties
    const lat = parseFloat(property.latitude);
    const lng = parseFloat(property.longitude);

    if (isNaN(lat) || isNaN(lng)) {
      console.warn("Invalid coordinates for property:", property.zip5 || property.addrline1);
      return;
    }

    // Close any existing popups
    const existingPopups = document.getElementsByClassName('mapboxgl-popup');
    if (existingPopups.length) {
      Array.from(existingPopups).forEach(popup => popup.remove());
    }

    //  Fly to the location with smooth animation
    mapRef.current.flyTo({
      center: [lng, lat],
      zoom: 17, // Closer zoom for parcel view
      essential: true,
      duration: 1500,
      pitch: 0, // Optional: adjust viewing angle
    });

    //  Show popup at location with parcel details
    new mapboxgl.Popup({
      closeButton: true,
      closeOnClick: true,
      offset: 25
    })
      .setLngLat([lng, lat])
      .setHTML(`
      <div style="
        background:#fff;
        padding:14px;
        border-radius:8px;
        box-shadow:0 2px 8px rgba(0,0,0,0.15);
        font-family:Inter, sans-serif;
        font-size:13px;
        width:240px;
      ">
        <h3 style="margin:0 0 8px 0; color:#1565C0; font-size:15px; font-weight:600;">
          ${property.addrline1 || "N/A"}
        </h3>
        <hr style="border:none; border-top:1px solid #eee; margin:8px 0;">
        <p style="margin:4px 0; font-size:12px;">
          <strong>Location:</strong> ${property.city || "N/A"}, ${property.county || "N/A"}, ${property.state || "N/A"} ${property.zip5 || ""}
        </p>
        <p style="margin:4px 0; font-size:12px;">
          <strong>Flood Risk:</strong> ${property._floodRisk || property.floodfemarisk || "N/A"}
        </p>
           <p style="margin:4px 0; font-size:12px;">
          <strong>Flood Zone:</strong> ${property.parcelcustomfemaflood || "N/A"}
        </p>
        <p style="margin:4px 0; font-size:12px;">
          <strong>Parcel Size:</strong> ${property.parcelsize || property._area || "N/A"} sq ft
        </p>
        <p style="margin:4px 0; font-size:12px;">
          <strong>Zoning:</strong> ${property.zonedcodelocal || "N/A"}
        </p>
        ${property.zestimate ? `
          <p style="margin:4px 0; font-size:12px;">
            <strong>Price:</strong> ${formatCurrency(property.zestimate)}
          </p>
        ` : ''}
      </div>
    `)
      .addTo(mapRef.current);
  };

  //  Reset zone code filter when county changes
  useEffect(() => {
    if (countyFilter !== "All") {
      // Reset zone code to "All" when county changes
      setZoneCodeFilter("All");
    }
  }, [countyFilter]);


  // Load Map + Data
  useEffect(() => {
    if (mapRef.current) return;

    mapRef.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/light-v11",
      // center: [-82.5929, 28.8917], // Florida approx center
      // zoom: 16,


      // center: [-79.4667, 35.5333],
      // center: [-79.001, 35.999],
      // zoom: 9,

      center: [-78.6443, 35.7877], // North Carolina approx center
      zoom: 12,
    });

    mapRef.current.addControl(new mapboxgl.NavigationControl(), "bottom-right");

    mapRef.current.on("load", async () => {
      try {
        const response = await fetch(`/assets/parcel/${parcelFile}`);
        const data = await response.json();
        // setParcelData(data.features || []);
        // setFilteredParcels(data.features || []);

        // Sort parcels initially by AreaBuilding (largest first)
        const sorted = (data.features || []).sort(
          (a, b) => (parseFloat(b.properties?.AreaBuilding) || 0) - (parseFloat(a.properties?.AreaBuilding) || 0)
        );
        // setParcelData(sorted);
        // setFilteredParcels(sorted);

        // normalize flood risk and lat/lon; attach normalized key property to each feature
        sorted.forEach((f) => {
          const p = f.properties || {};
          // normalize flood from common property names
          const flood =
            //  p.FloodFemaRisk ??
            p.floodfemarisk ??
            p.FloodRisk ??
            p.fema_category ??
            p.flood_risk ??
            p.flood ??
            "Unknown";
          p._floodRisk = String(flood);

          // --- normalize area into square feet on load ---
          // check common area fields, support values in acres (convert to sqft)
          const rawAreaCandidates = [
            p.parcelsize,
            p.AreaLotSF,
            p.AreaBuilding,
            p.area,
            p.area_sqft,
            p.lotsize,
            p.LotSizeSqFt,
          ];
          let areaVal = null;
          for (const v of rawAreaCandidates) {
            if (v === undefined || v === null) continue;
            const s = String(v).trim();
            // if contains "acre" convert
            if (/acre/i.test(s)) {
              const num = parseFloat(s.replace(/[^\d.\-]/g, ""));
              if (!Number.isNaN(num)) {
                areaVal = Math.round(num * 43560);
                break;
              }
            }
            // numeric string
            const num = parseFloat(s.replace(/[^\d.\-]/g, ""));
            if (!Number.isNaN(num)) {
              areaVal = num;
              break;
            }
          }
          // fallback 0
          p._area = Number.isFinite(areaVal) ? Number(areaVal) : 0;

          // ensure numeric coords exist on properties (used for point layer)
          if (p.longitude !== undefined) p.longitude = Number(p.longitude);
          if (p.latitude !== undefined) p.latitude = Number(p.latitude);
          // leave other properties intact
          f.properties = p;
        });

        setParcelData(sorted);
        setFilteredParcels(sorted);

        // compute unique flood options from normalized values
        const uniqFloods = Array.from(new Set(sorted.map((f) => f.properties?._floodRisk || "Unknown")));
        setFloodOptions(["All", ...uniqFloods.sort()]);

        const pointFeatures = sorted.map(f => ({
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [f.properties.longitude, f.properties.latitude],
          },
          properties: f.properties,
        }));

        const pointGeoJSON = {
          type: "FeatureCollection",
          features: pointFeatures,
        };

        // Create color expression now
        const colorExpr = buildZoneColorExpression(sorted);

        // Initialize map layers



        const viewToggle = new MapViewToggleControl(

          () => setMapViewMode("polygons"),

          () => setMapViewMode("points"),

          showPoints

        );

        // mapRef.current.addControl(viewToggle, "top");
        //  // --- Add the second GeoJSON polygon layer ---
        // const geoUrls = [
        //   "/assets/parcel/fema-flood-hazard-areas-12075-not-x.geojson",
        //   "/assets/parcel/fema-flood-hazard-areas-12017-not-x.geojson",

        // ];
        // const allFeatures = [];

        // // Fetch and merge all geojson files
        // for (const url of geoUrls) {
        //   const res = await fetch(url);
        //   const data = await res.json();
        //   allFeatures.push(...data.features);
        // }

        // const mergedData = {
        //   type: "FeatureCollection",
        //   features: allFeatures,
        // };

        // // Add or update source
        // if (!mapRef.current.getSource("merged-zones")) {
        //   mapRef.current.addSource("merged-zones", {
        //     type: "geojson",
        //     data: mergedData,
        //   });
        // } else {
        //   mapRef.current.getSource("merged-zones").setData(mergedData);
        // }

        // // Fill layer with zone-type-based color
        // if (!mapRef.current.getLayer("zones-fill")) {
        //   mapRef.current.addLayer({
        //     id: "zones-fill",
        //     type: "fill",
        //     source: "merged-zones",
        //     paint: {
        //       "fill-opacity": 0.2,
        //       "fill-color": [
        //         "match",
        //         ["get", "zonetype"], // <-- Make sure this property exists in your GeoJSON

        //         "X", "#4CAF50",
        //         "AE", "#FF9800",
        //         "VE", "#E91E63",
        //         "A", "#2196F3",

        //   /* default */ "#9E9E9E"
        //       ],
        //     },
        //   });
        // }

        //polygon plotting
        mapRef.current.addSource("parcel-source", {
          type: "geojson",
          data: { type: "FeatureCollection", features: sorted },
        });

        mapRef.current.addLayer({
          id: "parcel-fill",
          type: "fill",
          source: "parcel-source",
          layout: { visibility: showPoints ? "none" : "visible" },
          paint: {
            "fill-color": [
              "match",
              ["get", "parcelcustomfemaflood"], //  Use normalized field
              "X", "#4CAF50",      // Green - Minimal Risk
              "AE", "#FF9800",     // Orange - High Risk + BFE
              "VE", "#E91E63",     // Pink - Coastal + BFE
              "A", "#2196F3",      // Blue - High Risk (No BFE)
              "AH", "#FF6B6B",     // Light Red - Shallow Flooding
              "AO", "#FFA07A",     // Light Salmon - Sheet Flow
              "V", "#C71585",      // Medium Violet Red - Coastal Flood
              "#9E9E9E"            // Gray - Default/Unknown
            ],
            //  "fill-color": colorExpr,
            "fill-opacity": 0.45,
          },
        });

        mapRef.current.addLayer({
          id: "parcel-outline",
          type: "line",
          source: "parcel-source",
          layout: { visibility: showPoints ? "none" : "visible" },
          paint: {
            // "line-color": "#2E7D32",
            // // "line-color": colorExpr,
            // "line-width": 1.3,

            // "line-color": "#333333",
            "line-color": [
              "match",
              ["get", "parcelcustomfemaflood"], //  Use normalized field
              "X", "#4CAF50",      // Green - Minimal Risk
              "AE", "#FF9800",     // Orange - High Risk + BFE
              "VE", "#E91E63",     // Pink - Coastal + BFE
              "A", "#2196F3",      // Blue - High Risk (No BFE)
              "AH", "#FF6B6B",     // Light Red - Shallow Flooding
              "AO", "#FFA07A",     // Light Salmon - Sheet Flow
              "V", "#C71585",      // Medium Violet Red - Coastal Flood
              "#9E9E9E"            // Gray - Default/Unknown
            ],
            "line-width": 1,
          },
        });

        // point plotting
        mapRef.current.addSource("parcel-points", {
          type: "geojson",
          data: pointGeoJSON,
        });

        mapRef.current.addLayer({
          id: "parcel-points-layer",
          type: "circle",
          source: "parcel-points",
          layout: { visibility: showPoints ? "visible" : "none" },
          paint: {
            "circle-radius": 10,
            // "circle-color": "#fe5c5c",
            "circle-color": "#2E7D32",
            // "circle-color": colorExpr,
            "circle-stroke-width": 1,
            "circle-stroke-color": "#ffffff",
          },

        });


        try {
          // ensure polygon layers visible and points hidden
          if (mapRef.current.getLayer("parcel-fill")) mapRef.current.setLayoutProperty("parcel-fill", "visibility", "visible");
          if (mapRef.current.getLayer("parcel-outline")) mapRef.current.setLayoutProperty("parcel-outline", "visibility", "visible");
          if (mapRef.current.getLayer("parcel-points-layer")) mapRef.current.setLayoutProperty("parcel-points-layer", "visibility", "none");
        } catch (e) { /* ignore if layers not ready */ }
        // update internal state control visuals
        setShowPoints(false);
        try { if (typeof viewToggle.update === "function") viewToggle.update(false); if (typeof viewToggle.updateActive === "function") viewToggle.updateActive(mapRef.current); } catch (e) { }


      } catch (err) {
        console.error("Error loading parcels:", err);
      }

      // Popup on click
      mapRef.current.on("click", "parcel-fill", (e) => {   // change the id to switch point and ploygon
        const props = e.features[0].properties;

        new mapboxgl.Popup()
          .setLngLat(e.lngLat)
          .setHTML(`
              <div style="
                background:#fff;
                padding:14px;
                border-radius:8px;
                box-shadow:0 2px 8px rgba(0,0,0,0.15);
                font-family:Inter, sans-serif;
                font-size:13px;
                width:240px;">
                
                <h3 style="margin:0 0 6px 0; color:#1565C0; font-size:15px;">
                  ${props.addrline1 || "N/A"}, ${props.city || ""},  ${props.county || ""}, ${props.state || ""} ${props.zip5 || ""}
                </h3>
                
                <hr style="border:none; border-top:1px solid #eee; margin:8px 0;">
                 <p><strong>Flood Risk:</strong> ${props._floodRisk || props.floodfemarisk || "N/A"}</p>
                <p><strong>Parcel Size:</strong> ${props.parcelsize || "N/A"}</p>
                <strong>Flood Zone:</strong> ${props.parcelcustomfemaflood || "N/A"}<br/>
                <p><strong>Zoning:</strong>  ${props.zonedcodelocal ? `${props.zonedcodelocal} ` : "N/A"}</p>
                
              </div>
            `)
          .addTo(mapRef.current);
      });



      // Also enable popup for point layer
      mapRef.current.on("click", "parcel-points-layer", (e) => {
        const feat = (e.features && e.features[0]) || mapRef.current.queryRenderedFeatures(e.point, { layers: ["parcel-points-layer"] })[0];
        if (!feat) return;
        const props = feat.properties || {};
        const coords = (feat.geometry && feat.geometry.type === "Point" && feat.geometry.coordinates) || e.lngLat;

        new mapboxgl.Popup()
          .setLngLat(coords)
          .setHTML(`
              <div style="
                background:#fff;
                padding:14px;
                border-radius:8px;
                box-shadow:0 2px 8px rgba(0,0,0,0.15);
                font-family:Inter, sans-serif;
                font-size:13px;
                width:260px;">
                
                <h3 style="margin:0 0 6px 0; color:#1565C0; font-size:15px;">
                  ${props.addrline1 || "N/A"}, ${props.city || ""}, ${props.county || ""}, ${props.state || ""} ${props.zip5 || ""}
                </h3>
                
                <hr style="border:none; border-top:1px solid #eee; margin:8px 0;">
                 <p><strong>Flood Risk:</strong> ${props._floodRisk || props.floodfemarisk || "N/A"}</p>
                <p><strong>Parcel Size:</strong> ${props.parcelsize || "N/A"}</p>
                <p><strong>Zoning:</strong>  ${props.zonedcodelocal ? `${props.zonedcodelocal} ` : "N/A"}</p>
                
              </div>
            `)
          .addTo(mapRef.current);
      });

      // change cursor for both layers
      ["parcel-fill", "parcel-points-layer"].forEach((layerId) => {
        mapRef.current.on("mouseenter", layerId, () => (mapRef.current.getCanvas().style.cursor = "pointer"));
        mapRef.current.on("mouseleave", layerId, () => (mapRef.current.getCanvas().style.cursor = ""));
      });



    });
  }, []);

  const normalizeListed = (raw) => {
    if (raw === null || raw === undefined) return "Not listed";
    const s = String(raw).trim().replace(/\s/g, " ");
    return s === "" ? "Not listed" : s;
  };

  const getListedRaw = (props = {}) => {
    return (
      props.listedsale ??
      props.listed_sale ??
      props.listedSale ??
      props.ListedSale ??
      props.listingsale ??
      props.listedsales ??
      null
    );
  };

  // Compute min/max for sliders dynamically
  useEffect(() => {
    if (parcelData.length > 0) {

      // Extract unique counties
      const counties = Array.from(
        new Set(
          parcelData.map((f) => {
            const p = f.properties || {};
            return p.county || p.County || p.COUNTY || "Unknown";
          })
        )
      ).sort();
      setCountyOptions(["All", ...counties]);

      // build unique listed sale options using the shared normalizer/accessor
      const vals = parcelData.map((f) => normalizeListed(getListedRaw(f.properties || {})));
      const unique = Array.from(new Set(vals));
      unique.sort((a, b) => {
        if (a === "Not listed" && b !== "Not listed") return 1;
        if (b === "Not listed" && a !== "Not listed") return -1;
        return a.localeCompare(b);
      });
      setListedSaleOptions(unique);



      // const areaValues = parcelData
      //   .map((f) => parseFloat(f.properties?._area || 0))
      //   .filter((v) => v > 0);
      // if (areaValues.length > 0) {
      //   let minArea = Math.min(...areaValues);
      //   let maxArea = Math.max(...areaValues);
      //   if (minArea === maxArea) {
      //     minArea = Math.max(0, minArea - 1);
      //     maxArea = maxArea + 1;
      //   }
      //   setSliderMinArea(minArea);
      //   setSliderMaxArea(maxArea);
      //   // initialize areaRange to full span
      //   setAreaRange([minArea, maxArea]);
      // }

      const areaValues = parcelData
        .map((f) => parseFloat(f.properties?.arealotsf || f.properties?.AreaLotSF || f.properties?._area || 0))
        .filter((v) => v > 0);
      if (areaValues.length > 0) {
        let minArea = Math.min(...areaValues);
        let maxArea = Math.max(...areaValues);
        if (minArea === maxArea) {
          minArea = Math.max(0, minArea - 1);
          maxArea = maxArea + 1;
        }
        setSliderMinArea(minArea);
        setSliderMaxArea(maxArea);
        setAreaRange([minArea, maxArea]);
      }

      //  Zestimate
      const zestimateValues = parcelData
        .map(f => parseFloat(f.properties?.zestimate) || 0)
        .filter(v => v > 0);
      if (zestimateValues.length > 0) {
        const minZestimate = Math.min(...zestimateValues);
        const maxZestimate = Math.max(...zestimateValues);
        setSliderMinZestimate(minZestimate);
        setSliderMaxZestimate(maxZestimate);
        setZestimateRange([minZestimate, maxZestimate]);
      }

      //  Spread Percentage
      const spreadValues = parcelData
        .map(f => parseFloat(f.properties?.spreadpercentage) || 0)
        .filter(v => v !== 0);
      if (spreadValues.length > 0) {
        const minSpread = Math.min(...spreadValues);
        const maxSpread = Math.max(...spreadValues);
        setSliderMinSpread(minSpread);
        setSliderMaxSpread(maxSpread);
        setSpreadRange([minSpread, maxSpread]);
      }
    }
  }, [parcelData]);



  // Apply filters
  useEffect(() => {
    const filtered = parcelData.filter((f) => {
      const props = f.properties || {};
      const landValue = parseFloat(props.landvalueperunit) || 0;
      // const area = parseFloat(props._area) || 0;
      const area = parseFloat(props.arealotsf || props.AreaLotSF || props._area) || 0;
      const flood = props._floodRisk || props.FloodRisk || props.floodfemarisk || "Unknown";
      const zone =
        props.zonedcodelocal ?? props.ZonedCodeLocal ?? props.ZonedCode ?? props.ZoneCode ?? props.zoning ?? "Unknown";
      const zestimate = parseFloat(props.zestimate) || 0;
      const spread = parseFloat(props.spreadpercentage) || 0;

      // --- Land Value filter ---
      const matchLandValue = landValue >= priceRange[0] && landValue <= priceRange[1];

      // --- Area filter ---
      const matchArea = area >= areaRange[0] && area <= areaRange[1];

      // --- Flood Risk filter ---
      const matchFlood =
        floodRiskFilter === "All" ||
        String(flood).toLowerCase().includes(String(floodRiskFilter).toLowerCase());

      // --- Zone Code filter ---
      const matchZone =
        zoneCodeFilter === "All" ||
        String(zone).toLowerCase() === String(zoneCodeFilter).toLowerCase();

      // --- Zestimate filter ---
      const matchZestimate = zestimate >= zestimateRange[0] && zestimate <= zestimateRange[1];

      //   County matching
      const county = props.county || props.County || props.COUNTY || "Unknown";
      const matchCounty = countyFilter === "All" || String(county).toLowerCase() === String(countyFilter).toLowerCase();

      // --- Spread % filter ---
      const matchSpread = spread >= spreadRange[0] && spread <= spreadRange[1];

      // Listed sale: normalize using helper and compare
      const listedVal = normalizeListed(getListedRaw(props));
      //  const matchListed = listedSaleFilter === "All" || listedVal === listedSaleFilter;
      let matchListed = true;
      if (showOnlyListed) {
        const listedVal = normalizeListed(getListedRaw(props));
        // Show only if NOT "Not listed" (i.e., has a listing status)
        matchListed = listedVal !== "Not listed";
      }

      return (
        matchLandValue &&
        matchArea &&
        matchFlood &&
        matchZone &&
        matchZestimate &&
        matchSpread &&
        matchListed &&
        matchCounty
      );
    });

    setFilteredParcels(filtered);

    // update map sources
    try {
      if (mapRef.current?.getSource("parcel-source")) {
        mapRef.current.getSource("parcel-source").setData({
          type: "FeatureCollection",
          features: filtered,
        });
      }

      const pointFeatures = (filtered || [])
        .map((f) => {
          const props = f.properties || {};
          if (f.geometry && f.geometry.type === "Point" && Array.isArray(f.geometry.coordinates)) {
            return { type: "Feature", geometry: { type: "Point", coordinates: f.geometry.coordinates }, properties: props };
          }
          const lon = props.longitude ?? props.lon ?? props.x;
          const lat = props.latitude ?? props.lat ?? props.y;
          if (lon == null || lat == null) return null;
          const lonNum = Number(lon);
          const latNum = Number(lat);
          if (Number.isFinite(lonNum) && Number.isFinite(latNum)) {
            return { type: "Feature", geometry: { type: "Point", coordinates: [lonNum, latNum] }, properties: props };
          }
          return null;
        })
        .filter(Boolean);

      if (mapRef.current?.getSource("parcel-points")) {
        mapRef.current.getSource("parcel-points").setData({
          type: "FeatureCollection",
          features: pointFeatures,
        });
      }
    } catch (e) {
      console.warn("Failed to update map sources for filtered parcels:", e);
    }
  }, [
    parcelData,
    priceRange,
    areaRange,
    floodRiskFilter,
    zoneCodeFilter,
    zestimateRange,
    spreadRange,
    listedSaleFilter,
    showOnlyListed,
    countyFilter
  ]);



  const formatCurrency = (num) =>
    num ? "$" + num.toLocaleString("en-US") : "N/A";

  // set view mode explicitly (polygons = 'polygons', points = 'points')
  const setMapViewMode = (mode = "polygons") => {
    const showPts = mode === "points";
    setShowPoints(showPts);
    if (!mapRef.current) return;
    try {
      if (mapRef.current.getLayer("parcel-fill")) {
        mapRef.current.setLayoutProperty("parcel-fill", "visibility", showPts ? "none" : "visible");
      }
      if (mapRef.current.getLayer("parcel-outline")) {
        mapRef.current.setLayoutProperty("parcel-outline", "visibility", showPts ? "none" : "visible");
      }
      if (mapRef.current.getLayer("parcel-points-layer")) {
        mapRef.current.setLayoutProperty("parcel-points-layer", "visibility", showPts ? "visible" : "none");
      }
    } catch (err) {
      // ignore
    }
  };


  // toggle polygon / point visibility
  const handleToggleView = () => {
    setShowPoints((s) => {
      const next = !s;
      if (!mapRef.current) return next;
      try {
        // show/hide layers
        if (mapRef.current.getLayer("parcel-fill")) {
          mapRef.current.setLayoutProperty("parcel-fill", "visibility", next ? "none" : "visible");
        }
        if (mapRef.current.getLayer("parcel-outline")) {
          mapRef.current.setLayoutProperty("parcel-outline", "visibility", next ? "none" : "visible");
        }
        if (mapRef.current.getLayer("parcel-points-layer")) {
          mapRef.current.setLayoutProperty("parcel-points-layer", "visibility", next ? "visible" : "none");
        }
      } catch (err) {
        // ignore
      }
      return next;
    });
  };

  // --- helper to detect if a filter is active (non-default) ---
  const isPriceActive = () =>
    sliderMinPrice !== undefined && sliderMaxPrice !== undefined &&
    (priceRange[0] !== sliderMinPrice || priceRange[1] !== sliderMaxPrice);

  const isAreaActive = () =>
    sliderMinArea !== undefined && sliderMaxArea !== undefined &&
    (areaRange[0] !== sliderMinArea || areaRange[1] !== sliderMaxArea);



  const isZestimateActive = () => {
    // don't show active while no data or slider bounds not computed
    if (!parcelData || parcelData.length === 0) return false;
    if (sliderMinZestimate === undefined || sliderMaxZestimate === undefined) return false;
    return zestimateRange[0] !== sliderMinZestimate || zestimateRange[1] !== sliderMaxZestimate;
  };


  const isSpreadActive = () => {
    if (!parcelData || parcelData.length === 0) return false;
    if (sliderMinSpread === undefined || sliderMaxSpread === undefined) return false;
    return spreadRange[0] !== sliderMinSpread || spreadRange[1] !== sliderMaxSpread;
  };

  const isFloodActive = () => floodRiskFilter && floodRiskFilter !== "All";
  const isZoneActive = () => zoneCodeFilter && zoneCodeFilter !== "All";
  const isCountyActive = () => countyFilter && countyFilter !== "All";

  const isAppreciationActive = () => (appreciationValue && appreciationValue !== "All") || (appreciationFilter && appreciationFilter !== "All");

  // reset all filters to defaults and close dropdowns
  const clearAllFilters = () => {
    // reset ranges to computed slider min/max (if available) else fallback
    setPriceRange([sliderMinPrice ?? 0, sliderMaxPrice ?? 1000000]);
    setAreaRange([sliderMinArea ?? 0, sliderMaxArea ?? 5000]);
    setZestimateRange([sliderMinZestimate ?? 0, sliderMaxZestimate ?? 1000000]);
    setSpreadRange([sliderMinSpread ?? -100, sliderMaxSpread ?? 100]);

    setFloodRiskFilter("All");
    setZoneCodeFilter("All");
    setCountyFilter("All");
    setAppreciationValue("All");
    setAppreciationFilter && setAppreciationFilter("All");
    setListedSaleFilter("All");
    setShowOnlyListed(false);

    // close dropdowns
    setShowPriceFilter(false);
    setShowAreaFilter(false);
    setShowFloodFilter(false);
    setShowZoneFilter(false);
    setShowZestimateFilter(false);
    setShowSpreadFilter(false);

    // reset filtered list to full data
    setFilteredParcels(parcelData || []);
    // update map source if exists
    try {
      if (mapRef.current?.getSource("parcel-source")) {
        mapRef.current.getSource("parcel-source").setData({ type: "FeatureCollection", features: parcelData || [] });
      }
    } catch (e) { }
  };

  return (
    <>

      <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
        <Header
          activeTab={"parcels"}
          handleTabChange={handleTabChange}
          toggleMenu={toggleMenu}
          isMenuOpen={isMenuOpen}
          handleLogout={handleLogout}
          geocoderContainerRef={geocoderContainerRef}
          showSearch={true}
          showFavorites={false}
          showLinks={true}
          //   handleUpgrade={handleUpgrade}
          isSubscribed={isSubscribed}
        />




        {/* <div className="subHeaderOuter" style={{ padding: "8px 12px" }}> */}
        <div className="subHeaderOuter" style={{ padding: "8px 12px" }}>


          {/* Filter Buttons */}
          <div
            className="filterOuter"
            style={{
              display: "flex",
              gap: "10px",
              padding: "10px",
              // background: "#f5f5f5",
              borderBottom: "1px solid #ddd",
              position: "relative"
            }}
          >
            {/* Land Value */}
            <Button
              variant="contained"
              color="primary filter-button"
              endIcon={<ArrowDropDownIcon />}
              onClick={() => {
                setShowPriceFilter(!showPriceFilter);
                setShowFloodFilter(false);
                setShowAreaFilter(false);
                setShowZoneFilter(false);
                setShowZestimateFilter(false);
                setShowSpreadFilter(false);
                setShowCountyFilter(false);
              }}
              style={{
                textTransform: "none",
                background: isPriceActive() ? "#1c8f7d" : "transparent",
                color: isPriceActive() ? "#fff" : "#333",
                boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                borderRadius: 6,
              }}
            >
              Land Value
            </Button>

            {/* Zestimate */}
            <Button
              color="primary filter-button"
              variant="contained"
              endIcon={<ArrowDropDownIcon />}
              onClick={() => {
                setShowZestimateFilter(!showZestimateFilter);
                setShowPriceFilter(false);
                setShowAreaFilter(false);
                setShowFloodFilter(false);
                setShowZoneFilter(false);
                setShowSpreadFilter(false);
                setShowCountyFilter(false);
              }}
              style={{
                textTransform: "none",
                background: isZestimateActive() ? "#1c8f7d" : "transparent",
                color: isZestimateActive() ? "#fff" : "#333",
                boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                borderRadius: 6,
              }}
            >
              Price
            </Button>

            {/* Spread % */}
            <Button
              color="primary filter-button"
              variant="contained"
              endIcon={<ArrowDropDownIcon />}
              onClick={() => {
                setShowSpreadFilter(!showSpreadFilter);
                setShowPriceFilter(false);
                setShowAreaFilter(false);
                setShowFloodFilter(false);
                setShowZoneFilter(false);
                setShowZestimateFilter(false);
                setShowCountyFilter(false);
              }}
              style={{
                textTransform: "none",
                background: isSpreadActive() ? "#1c8f7d" : "transparent",
                color: isSpreadActive() ? "#fff" : "#333",
                boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                borderRadius: 6,
              }}
            >
              Spread %
            </Button>

            {/* Flood Risk */}
            {/* <Button
              color="primary filter-button"
              variant="contained"
              endIcon={<ArrowDropDownIcon />}
              onClick={() => {
                setShowFloodFilter(!showFloodFilter);
                setShowPriceFilter(false);
                setShowAreaFilter(false);
                setShowZoneFilter(false);
                setShowZestimateFilter(false);
                setShowSpreadFilter(false);
              }}
              style={{
                textTransform: "none",
                background: isFloodActive() ? "#1c8f7d" : "transparent",
                color: isFloodActive() ? "#fff" : "#333",
                boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                borderRadius: 6,
              }}

            >
              Flood Risk
            </Button> */}

            {/* Area */}
            <Button
              color="primary filter-button"
              variant="contained"
              endIcon={<ArrowDropDownIcon />}
              onClick={() => {
                setShowAreaFilter(!showAreaFilter);
                setShowPriceFilter(false);
                setShowFloodFilter(false);
                setShowZoneFilter(false);
                setShowZestimateFilter(false);
                setShowSpreadFilter(false);
                setShowCountyFilter(false);
              }}
              style={{
                textTransform: "none",
                background: isAreaActive() ? "#1c8f7d" : "transparent",
                color: isAreaActive() ? "#fff" : "#333",
                boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                borderRadius: 6,
              }}
            >
              Parcel Size
            </Button>

            {/* Zone Code */}
            <Button
              color="primary filter-button"
              variant="contained"
              endIcon={<ArrowDropDownIcon />}
              onClick={() => {
                setShowZoneFilter(!showZoneFilter);
                setShowPriceFilter(false);
                setShowAreaFilter(false);
                setShowFloodFilter(false);
                setShowZestimateFilter(false);
                setShowSpreadFilter(false);
                setShowCountyFilter(false);
              }}
              style={{
                textTransform: "none",
                background: isZoneActive() ? "#1c8f7d" : "transparent",
                color: isZoneActive() ? "#fff" : "#333",
                boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                borderRadius: 6,
              }}
            >
              Zone Code
            </Button>

            {/*  County Filter Button */}
            <Button
              color="primary filter-button"
              variant="contained"
              endIcon={<ArrowDropDownIcon />}
              onClick={() => {
                setShowCountyFilter(!showCountyFilter);
                setShowPriceFilter(false);
                setShowAreaFilter(false);
                setShowFloodFilter(false);
                setShowZoneFilter(false);
                setShowZestimateFilter(false);
                setShowSpreadFilter(false);
              }}
              style={{
                textTransform: "none",
                background: isCountyActive() ? "#1c8f7d" : "transparent",
                color: isCountyActive() ? "#fff" : "#333",
                boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                borderRadius: 6,
              }}
            >
              {/* "County - CountyName" when selected, otherwise just "County" */}
  {countyFilter === "All" ? "County" : `County - ${countyFilter}`}
            </Button>




            {/* Listed Sale (button + dropdown) */}
            {/* <div style={{ position: "relative", display: "inline-block" }}>
              <Button
                color="primary filter-button"
                variant="contained"
                endIcon={<ArrowDropDownIcon />}
                onClick={() => {
                  setShowListedSaleFilter(!showListedSaleFilter);
                  setShowPriceFilter(false);
                  setShowAreaFilter(false);
                  setShowFloodFilter(false);
                  setShowZoneFilter(false);
                  setShowZestimateFilter(false);
                  setShowSpreadFilter(false);
                }}
                style={{
                  textTransform: "none",
                  background: listedSaleFilter && listedSaleFilter !== "All" ? "#1c8f7d" : "transparent",
                  color: listedSaleFilter && listedSaleFilter !== "All" ? "#fff" : "#333",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                  borderRadius: 6,
                }}
              >
                Listed Sale
              </Button>

              {showListedSaleFilter && (
                <div
                  style={{
                    position: "absolute",
                    top: 42,
                    left: 0,
                    background: "#fff",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                    borderRadius: 6,
                    zIndex: 999,
                    minWidth: 180,
                    maxHeight: 320,
                    overflow: "auto",
                  }}
                >
                  <div
                    onClick={() => {
                      setListedSaleFilter("All");
                      setShowListedSaleFilter(false);
                    }}
                    style={{
                      padding: "8px 12px",
                      cursor: "pointer",
                      background: listedSaleFilter === "All" ? "#1c8f7d" : "transparent",
                      color: listedSaleFilter === "All" ? "#fff" : "#000",
                    }}
                  >
                    All
                  </div>
                  {listedSaleOptions.map((opt) => (
                    <div
                      key={opt}
                      onClick={() => {
                        setListedSaleFilter(opt);
                        setShowListedSaleFilter(false);
                      }}
                      style={{
                        padding: "8px 12px",
                        cursor: "pointer",
                        background: listedSaleFilter === opt ? "#1c8f7d" : "transparent",
                        color: listedSaleFilter === opt ? "#fff" : "#000",
                      }}
                    >
                      {opt}
                    </div>
                  ))}
                </div>
              )}
            </div> */}

            {/* Listed Sales Checkbox */}
            <div
              style={{

                color: "#007c6f",
                /* background:#1c8f7d !important; */
                borderRadius: "20px ",
                boxShadow: "none ",
                border: "solid 1px #007c6f ",
                fontFamily: "var(--bs-body-font-family) ",
                padding: "6px 15px ",
                display: "flex",
                alignItems: "center", gap: "8px"

              }}
              onClick={() => setShowOnlyListed(!showOnlyListed)}
            >
              <input
                type="checkbox"
                checked={showOnlyListed}
                onChange={(e) => setShowOnlyListed(e.target.checked)}
                onClick={(e) => e.stopPropagation()} // Prevent double toggle
                style={{
                  width: "18px",
                  height: "18px",
                  cursor: "pointer",
                  accentColor: "#1c8f7d",
                }}
              />
              <span style={{
                fontSize: "12px",
                fontFamily: "var(--bs-body-font-family) !important",

                fontWeight: showOnlyListed ? "600" : "500",
                color: showOnlyListed ? "#1c8f7d" : "#333",
              }}>
                Listed for sales
              </span>
            </div>

            {/* Clear Filters button aligned to right */}
            <div style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
              <Button
                color="primary filter-button"
                variant="outlined"
                onClick={clearAllFilters}
                style={{ textTransform: "none", borderColor: "#cfcfcf", color: "#333", marginLeft: 8 }}
              >
                Clear Filters
              </Button>
            </div>

          </div>

          {/* LAND VALUE SLIDER */}
          {showPriceFilter && (
            <div className="price-filter-container"
              style={{

                left: 30,
                top: 153,

              }}>
              <ReactSlider
                className="horizontal-slider"
                thumbClassName="example-thumb"
                trackClassName="example-track"
                value={priceRange}
                onChange={setPriceRange}
                min={sliderMinPrice}
                max={sliderMaxPrice}
                step={(sliderMaxPrice - sliderMinPrice) / 100}
                pearling
                minDistance={(sliderMaxPrice - sliderMinPrice) / 10}
              />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>{formatCurrency(priceRange[0])}</span>
                <span>{formatCurrency(priceRange[1])}</span>
              </div>
            </div>
          )}

          {/* ZESTIMATE SLIDER */}
          {showZestimateFilter && (
            <div
              className="price-filter-container"
              style={{

                left: 170,
                top: 153,

              }}
            >
              <ReactSlider
                className="horizontal-slider"
                thumbClassName="example-thumb"
                trackClassName="example-track"
                value={zestimateRange}
                onChange={setZestimateRange}
                min={sliderMinZestimate}
                max={sliderMaxZestimate}
                step={1000}
                pearling
                minDistance={10000}
              />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>{formatCurrency(zestimateRange[0])}</span>
                <span>{formatCurrency(zestimateRange[1])}</span>
              </div>
            </div>
          )}

          {/* SPREAD % SLIDER */}
          {showSpreadFilter && (
            <div
              className="price-filter-container"
              style={{
                left: 310,
                top: 153,
              }}
            >
              <ReactSlider
                className="horizontal-slider"
                thumbClassName="example-thumb"
                trackClassName="example-track"
                value={spreadRange}
                onChange={setSpreadRange}
                min={sliderMinSpread}
                max={sliderMaxSpread}
                step={1}
                pearling
                minDistance={2}
              />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>{spreadRange[0]}%</span>
                <span>{spreadRange[1]}%</span>
              </div>
            </div>
          )}

          {/* AREA SLIDER */}
          {showAreaFilter && (
            <div
              className="price-filter-container"
              style={{
                position: "absolute",
                left: 440,
                top: 153,
              }}
            >
              <ReactSlider
                className="horizontal-slider"
                thumbClassName="example-thumb"
                trackClassName="example-track"
                value={areaRange}            // Must be [min, max]
                onChange={(value) => setAreaRange(value)}  // Accepts array
                min={sliderMinArea}
                max={sliderMaxArea}
                // step={1000}
                step={Math.max(1, Math.round((sliderMaxArea - sliderMinArea) / 100))}
                pearling
                // minDistance={10000}
                minDistance={Math.max(1, Math.round((sliderMaxArea - sliderMinArea) / 20))}

              />

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>{areaRange[0].toLocaleString()} sq ft</span>
                <span>{areaRange[1].toLocaleString()} sq ft</span>
              </div>
            </div>
          )}

          {/* FLOOD RISK DROPDOWN */}
          {/* {showFloodFilter && (
            <div
              style={{
                position: "absolute",
                top: 150,
                left: 191,
                background: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                borderRadius: "6px",
                zIndex: 999,
                padding: "6px 0",
                minWidth: "160px",
              }}
            >

              {floodOptions.map((risk) => (
                <div
                  key={risk}
                  onClick={() => {
                    setFloodRiskFilter(risk);
                    setShowFloodFilter(false);
                  }}
                  style={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    background: floodRiskFilter === risk ? "#1c8f7d" : "transparent",
                    color: floodRiskFilter === risk ? "#fff" : "#000",
                  }}
                >
                  {risk}
                </div>
              ))}

            </div>
          )} */}

          {/* ZONE CODE DROPDOWN */}
          {showZoneFilter && (
            <div
              style={{
                position: "absolute",
                top: 153,
                left: 550,
                background: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                borderRadius: "6px",
                zIndex: 999,
                padding: "6px 0",
                minWidth: "200px",
                maxHeight: "300px",
                overflow: "auto",
              }}
            >
              {zoneCodes.map((zc) => (
                <div
                  key={zc}
                  onClick={() => {
                    setZoneCodeFilter(zc);
                    setShowZoneFilter(false);
                  }}
                  style={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    background: zoneCodeFilter === zc ? "#1c8f7d" : "transparent",
                    color: zoneCodeFilter === zc ? "#fff" : "#000",
                    fontSize: 13,
                  }}
                >
                  {zc}
                </div>
              ))}
            </div>
          )}

          {/*  COUNTY DROPDOWN */}
          {showCountyFilter && (
            <div
              style={{
                position: "absolute",
                top: 153,
                left: 670, // Adjust position as needed
                background: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                borderRadius: "6px",
                zIndex: 999,
                padding: "6px 0",
                minWidth: "200px",
                maxHeight: "300px",
                overflow: "auto",
              }}
            >
              {countyOptions.map((county) => (
                <div
                  key={county}
                  onClick={() => {
                    setCountyFilter(county);
                    setShowCountyFilter(false);
                  }}
                  style={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    background: countyFilter === county ? "#1c8f7d" : "transparent",
                    color: countyFilter === county ? "#fff" : "#000",
                    fontSize: 13,
                  }}
                >
                  {county}
                </div>
              ))}
            </div>
          )}



        </div>


        <div className="mainOuter" style={{ display: "flex", height: "100vh", overflow: "hidden" }}>
          {/* LEFT SIDE PANEL */}
          <div
            className="listOuter"
            style={{
              width: "60%",
              height: "100%",
              borderRight: "1px solid #ddd",
              background: "#fafafa",
              display: "flex",
              flexDirection: "column",
              position: "relative"
            }}
          >


            {/* Property List */}
            <div style={{ flex: 1, height: "100%" }}>
              <PropertyList parcels={filteredParcels}
                onRowClick={handleRowClick}
              />
            </div>
          </div>



          <div style={{ flex: 1, position: "relative" }}>
            <div ref={mapContainer} style={{ width: "100%", height: "100%" }} />


            {/* FLOOD ZONE LEGEND - Bottom Center */}
            <div
              style={{
                position: "absolute",
                bottom: "10px",
                left: "50%",
                transform: "translateX(-50%)",
                background: "rgba(255, 255, 255, 0.95)",
                padding: "5px 5px",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.25)",
                fontFamily: "Inter, sans-serif",
                fontSize: "12px",
                zIndex: 1000,
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              {/* <span
        style={{
          fontWeight: "600",
          color: "#333",
          fontSize: "13px",
          marginRight: "5px",
        }}
      >
        FloodZone:
      </span> */}
              {FLOOD_ZONE_LEGEND.map((item) => (
                <div
                  key={item.zone}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <div
                    style={{
                      width: "18px",
                      height: "18px",
                      backgroundColor: item.color,
                      opacity: 0.5,
                      borderRadius: "3px",
                      border: "1px solid rgba(0,0,0,0.2)",
                    }}
                  />
                  <span style={{ color: "#555", fontSize: "11px", whiteSpace: "nowrap" }}>
                    {item.label}
                  </span>
                </div>
              ))}
            </div>

          </div>


        </div>
      </div>


    </>
  );
};

export default CarolinaComponent;
